//package import 
import React, { useEffect, useState } from "react";

//component import 
import { CusotomSearch } from "../../utils/resuableComponents/CustomSearch";
import ShareValueEdit from "../../utils/resuableComponents/ShareValueEdit";
import CustomModal from "../../utils/resuableComponents/CustomModal";
import { showToast } from "../../utils/constants/Toaster";
import { ShareManagementHeading, ErrorMessageShareMangement, DisableModalContentText, EnableModalContentText } from "../../utils/TextInputUtils";
import { columnsSharesList } from "../../utils/constants/TableHeader";
import { getSharesList } from "../../services/apiServices/GetServices";
import { createShare } from "../../services/apiServices/PostServices";
import Modal from 'react-bootstrap/Modal'
import CustomTable from "../../utils/resuableComponents/CustomTable";
import Loader from "../loadingScreens/Loader";

const ShareManagement = () => {

    const [isLoader, setIsLoader] = useState(false)
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [simpleModal, setSimpleModal] = useState(false)
    const [modalContentData, setModalContentData] = useState("")
    const [statusChecked, setStatuschecked] = useState(1)
    const [filteredData, setFilteredData] = useState([])
    const [shareData, setShareData] = useState([])
    const [shareName, setShareName] = useState("")
    const [shareValue, setShareValue] = useState("")
    const [searchTerm, setSearchTerm] = useState('');
    const [buttonDisable, setButtonDisable] = useState(false)
    const [onClickNo, setOnclickNo] = useState(false)
    const [shareInfo, setShareInfo] = useState()

    useEffect(() => {
        getShareList()
    }, [])

    //function to handle on change question
    const handleShareName = (e) => {
        let shareName = e.target.value;
        if (shareName.length === 1 && shareValue === ' ') {
            setShareName("");
        } else {
            setShareName(shareName)
        }
    };

    //api function call to get the share list
    const getShareList = async () => {
        try {
            const res = await getSharesList("allShare");
            if (res.success) {
                setFilteredData(res?.shares)
                setShareData(res?.shares)
            } else {
                console.log("res", res)
            }
        } catch (error) {
            console.log("error", error)
        }
    }

    //function to handle on change answer
    const handleShareValue = (e) => {
        let shareValue = e.target.value.toString()

        if (shareValue === ' ' && parseInt(shareValue) === 0) {
            // setInputValue(newInputValue);
            setShareValue("");
        } else {
            setShareValue(shareValue)
        }
    }

    //api function call to create new share
    const handleSubmitShare = async () => {
        const req_body = {
            id: 0,
            name: shareName,
            is_active: 1,
            value: parseInt(shareValue),

        }
        if (shareName === "" || shareValue === "") {
            showToast(3, ErrorMessageShareMangement)
        } else {
            try {
                const res = await createShare("createShare", req_body);
                if (res.success) {
                    showToast(1, res?.message)
                    setShareName("")
                    setShareValue("")
                    setIsModalOpen(false)
                    getShareList()
                } else {
                    console.log("res", res)
                }
            } catch (error) {
                console.log("error", error)
            }
        }
    }

    const handleCloseModal = () => {
        setIsModalOpen(false)
    }

    //api function call for the search functionality
    const handleSearch = (val) => {
        const searchVal = val
        if (searchVal === "") {
            setFilteredData(shareData)
        } else {
            setSearchTerm(searchVal);
            const filterdata = shareData.filter((item) => {
                if (item?.name.toLowerCase()
                    .includes(searchVal.toLowerCase())) { return item; }
            })
            setFilteredData(filterdata)
        }
    }

    //function call to close the modal 
    const closeSimpleModal = () => {      
        // setOnclickNo(true)
        setSimpleModal(false)
        setShareName("")
        setShareValue("")
    }

    //function call to change the conten to disable popup
    const handleModalContent = (val) => {
        if (val === 1) {
            setModalContentData(EnableModalContentText)
        } else {
            setModalContentData(DisableModalContentText)
        }
    }

    //function call to know about the status 
    const handledisableShares = async (check, data) => {
        setShareInfo(data)
        handleModalContent(check)
        setStatuschecked(check)
        setSimpleModal(true)
        // setOnclickNo(false)
    }

    //function call to close the modal
    const handleModalOpen = () => {
        setShareName("");
        setShareValue("")
        setIsModalOpen(true)
        setButtonDisable(false)
    }

    //api function call to disable the shares
    const handleDisableSharesApi = async () => {
        try {
            const req_body = {
                id: shareInfo?.id,
                name: shareInfo?.name,
                value: shareInfo?.value,
                is_active: statusChecked
            }

            const res = await createShare("createShare", req_body);
            if (res.success) {
                showToast(1, res?.message)
                setButtonDisable(true)
                setSimpleModal(false)
                getShareList()
            } else {
                console.log("res", res)
            }
        } catch (error) {
            console.log("error", error)
        }

    }


    return (
        <div className="col-lg-12 d-flex  flex-column">
            {isLoader ? <Loader /> : null}
            <div className="d-flex flex-row justify-content-between align-items-center w-100 border-bottom p-2">
                <h1 className="fs-4 mx-3 ps-1 Montserrat fw-semi-bold">
                    {ShareManagementHeading}
                </h1>
                <div className="d-flex flex-row ">
                    <div className="d-flex mx-2 pointer " onClick={() => handleModalOpen()} >
                        <h6 className="secondColor d-flex justify-content-center align-items-center fw-bold mx-2 m-0 w-100">
                            Add
                        </h6>
                        <i className="bi bi-plus-square colorPrimary"></i>
                    </div>
                </div>
            </div>
            <div className="d-flex justify-content-start">
                <CusotomSearch onChange={handleSearch} />
            </div>
            {/* <hr className="hr w-100 m-0 my-1" /> */}
            <CustomTable data={filteredData} columnHeader={columnsSharesList} openStoreDisable={handledisableShares}  />

            <Modal show={isModalOpen} onHide={handleCloseModal} centered size={"md"} backdrop="static" >
                <Modal.Header style={{ backgroundColor: "#0A2FB6", color: "white" }} data-bs-theme="dark" closeButton>
                    <h6 className="text-white fw-bold m-0 montserrat">{"Add"}</h6>
                </Modal.Header>
                <Modal.Body className="text-center p-4 pb-0">
                    <div className="">
                        <div className="mb-4" >
                            <input className="form-control form-control-lg" type="text" name="Share Name" placeholder="Share Name" value={shareName} aria-label="default input example" onChange={(e) => { handleShareName(e) }}></input>
                        </div>
                        <div className="mb-4" >
                            <input className="form-control form-control-lg" type="number" name="Share Value" placeholder="Share Value" value={shareValue} aria-label="default input example" onChange={(e) => { handleShareValue(e) }}></input>
                        </div>
                        <div className="d-flex flex-row justify-content-center my-1 mb-2  ">
                            <button disabled={buttonDisable} className="primaryButton w-25" onClick={() => handleSubmitShare()}  >{"Add"}</button>
                        </div>
                    </div>
                </Modal.Body>
            </Modal>

            <CustomModal
                close={closeSimpleModal}
                open={simpleModal}
                modalContent={modalContentData}
                Action={handleDisableSharesApi}
                statusCheck={statusChecked}
            />

        </div>
    )
}

export default ShareManagement